<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />

    <div class="mb-3">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="displayAsSlider"
          value="1"
          :id="`display-as-slider-${block.id}`"
        />
        <label class="form-check-label" :for="`display-as-slider-${block.id}`">
          <small>{{ 'Display as slider' | translate }}</small>
        </label>
      </div>
    </div>
    <div class="mb-3" v-if="displayAsSlider">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="sliderAutoplay"
          value="1"
          :id="`slider-autoplay-${block.id}`"
        />
        <label class="form-check-label" :for="`slider-autoplay-${block.id}`">
          <small>{{ 'Slider autoplay' | translate }}</small>
        </label>
      </div>
    </div>

    <draggable :list="columns" handle=".grabbable">
      <div
        v-for="(column, index) in columns"
        :key="column.id"
        class="card mb-3"
      >
        <div class="card-header d-flex justify-content-between">
          <i class="fas fa-bars grabbable"></i>
          <button
            @click="deleteColumn(index)"
            class="btn btn-outline-danger btn-sm"
          >
            {{ 'Delete' | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="mb-4">
            <ImageUpload
              :file-path="column.img"
              context="block.columns"
              @fileDeleted="imageDeleted(index, column)"
              @uploadCompleted="imageUploaded($event, index, column)"
            ></ImageUpload>
          </div>

          <div class="">
            <QuillInputS
              name="body"
              display-name=""
              placeholder="Body here"
              :value="column.quill"
              @quillChanged="
                (html, quill) => {
                  update(html, quill, index)
                }
              "
            ></QuillInputS>
          </div>
        </div>
      </div>
    </draggable>
    <div class="">
      <button @click="add" class="btn btn-primary">
        {{ 'Add' | translate }}
      </button>
    </div>
  </div>
</template>

<script>
import route from '~/routes.js'
import QuillInputS from './../QuillInputS'
import ImageUpload from './../ImageUpload'
import draggable from 'vuedraggable'

export default {
  components: {
    QuillInputS,
    ImageUpload,
    draggable,
  },
  props: ['block'],
  data() {
    return {
      columns: [...this.block.data].map((row, i) => {
        if (!row.id) {
          row.id = i + 1
        }
        return row
      }),
    }
  },
  computed: {
    displayAsSlider: {
      get() {
        return _.get(this, 'block.settings.display_as_slider')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', { ...settings, display_as_slider: value })
      },
    },
    sliderAutoplay: {
      get() {
        return _.get(this, 'block.settings.slider_autoplay')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          slider_autoplay: value,
        })
      },
    },
  },
  methods: {
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },

    imageUploaded(path, index, column) {
      this.$set(this.columns, index, {
        ...column,
        img: path,
      })
      this.updateBlock()
      this.$emit('saveAndContinue')
    },
    imageDeleted(index, column) {
      this.$set(this.columns, index, {
        ...column,
        img: null,
      })
      this.updateBlock()
      this.$emit('saveAndContinue')
    },
    deleteColumn(key) {
      this.$delete(this.columns, key)
    },

    update(html, quill, index) {
      this.$set(this.columns, index, { ...this.columns[index], quill, html })
      this.updateBlock()
    },

    add() {
      this.columns.push({
        id: this.columns.length + 1,
        quill: null,
        html: null,
        img: null,
      })
    },
    updateBlock() {
      this.block.data = this.columns
    },
  },
}
</script>
